var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from "@uigovpe/components";
var sidebarContainerStyle = {
    background: "#FFFFFF",
    border: "1px solid #D7E0EA",
    borderRadius: 20,
    padding: 20,
    position: "sticky",
    top: 24,
};
var mobileContainerStyle = {
    background: "#FFFFFF",
    border: "1px solid #D7E0EA",
    borderRadius: 16,
    marginBottom: 20,
    padding: 16,
};
var sidebarListStyle = {
    display: "grid",
    gap: 12,
};
var mobileListStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
};
var fullWidthButtonStyle = {
    justifyContent: "flex-start",
    width: "100%",
};
export var Menu = function (_a) {
    var currentPath = _a.currentPath, displayMode = _a.displayMode, navigationItems = _a.navigationItems, onClickItem = _a.onClickItem;
    if (navigationItems.length === 0) {
        return null;
    }
    var renderNavigationButton = function (item) { return (_jsx(Button, { label: item.label, onClick: function () { return onClickItem(item.path); }, outlined: currentPath !== item.path, severity: currentPath === item.path ? undefined : "secondary", size: "small", style: displayMode === "sidebar" ? fullWidthButtonStyle : undefined }, item.path)); };
    if (displayMode === "mobile") {
        return (_jsx("section", __assign({ style: mobileContainerStyle }, { children: _jsxs("div", __assign({ style: { display: "grid", gap: 12 } }, { children: [_jsx(Typography, __assign({ fontWeight: "medium", size: "sm" }, { children: "Navega\u00E7\u00E3o" })), _jsx("div", __assign({ style: mobileListStyle }, { children: navigationItems.map(renderNavigationButton) }))] })) })));
    }
    return (_jsx("aside", __assign({ style: sidebarContainerStyle }, { children: _jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(Typography, __assign({ fontWeight: "medium", size: "sm" }, { children: "Navega\u00E7\u00E3o" })), _jsx("div", __assign({ style: sidebarListStyle }, { children: navigationItems.map(renderNavigationButton) }))] })) })));
};
